{
  "markread": "oznacz jako przeczytane",
  "filter": "filtr",
  "newest": "najnowsze",
  "unread": "nieprzeczytane",
  "starred": "z gwiazdką",
  "tags": "Tagi",
  "alltags": "wszystkie",
  "timestamp": "{0,date} {0,time}",
  "hours": "przed {0,plural,one {godziną},other {# godzinami}}",
  "minutes": "przed {0,plural,one {minutą},other {# minutami}}",
  "seconds": "przed {0,plural,one {chwilą},other {# sekundami}}",
  "days": "{0,plural,zero {dzisiaj},one {wczoraj},other {przejrzany # dni temu}}",
  "star": "oznacz gwiazdką",
  "unstar": "usuń gwiazdkę",
  "mark": "oznacz jako przeczytane",
  "unmark": "oznacz jako nieprzeczytane",
  "load_img": "pobierz obrazy",
  "open_window": "otwórz",
  "next": "następny",
  "searchbutton": "szukaj",
  "searchremove": "ukryj wyszukiwanie",
  "refreshbutton": "odśwież",
  "settingsbutton": "opcje",
  "logoutbutton": "wyloguj",
  "loginbutton": "zaloguj",
  "sources": "Źródła",
  "source_add": "dodaj źródło",
  "source_opml": "lub zaimportuj plik OPML z Google Reader",
  "source_export": "eksportuj źródła",
  "source_edit": "edytuj",
  "source_filter": "Filtr",
  "source_delete": "usuń",
  "source_warn": "Czy na pewno chcesz usunąć to źródło?",
  "source_new": "nowe niezapisane źródło",
  "source_title": "Tytuł",
  "source_autotitle_hint": "Pozostaw puste, aby uzupełnić automatycznie",
  "source_tags": "Tagi",
  "source_pwd_placeholder": "bez zmian",
  "source_comma": "rozdzielone przecinkami",
  "source_select": "proszę wybrać typ źródła",
  "source_type": "Typ",
  "source_save": "zapisz",
  "source_cancel": "anuluj",
  "source_saved": "zapisano",
  "source_last_post": "Ostatni artykuł został przejrzany ",
  "source_refresh": "Odśwież to źródło",
  "no_entries": "brak wpisów",
  "more": "więcej",
  "login": "zaloguj",
  "login_username": "użytkownik",
  "login_password": "hasło",
  "login_invalid_credentials": "nieprawidłowy login lub hasło.",
  "no_title": "bez tytułu",
  "error": "wystąpił błąd",
  "streamerror": "Nie załadowano żadnych elementów, odświeżyć?",
  "error_loading": "Błąd podczas ładowania:",
  "experimental": "Eksperymentalny",
  "article_actions": "Działania",
  "share_native_label": "Udostępnij",
  "source_browse": "Przeglądaj",
  "app_reload": "Załaduj ponownie",
  "error_session_expired": "Sesja wygasła",
  "close_entry": "Zamknij",
  "sources_refreshed": "Odświeżono źródła",
  "error_unknown_tag": "Nieznany tag:"
}
